import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
  CHECK_LOGIN,
  LOGOUT_USER,
  FORCE_LOGOUT,
  CLEAR_ALL_LOGIN_MESSAGES,
  VERIFY_TOTP,
} from "./actionTypes";
import {
  apiError,
  clearAllLoginMessagesSuccessful,
  loginUserSuccessful,
  loginUserSuccessfulWithQrCode,
  loginUserSuccessfulWithVerification,
  verifyTotpSuccessful,
} from "./actions";
import { postLogin, postVerifyTotp } from "../../helpers/auth_helper";
import { jwtDecode } from "jwt-decode";
import EncryptPassword from "../../components/EncryptPassword";

function getErrorMessage(response) {
  if (!response) {
    return "No response is received";
  }
  if (response.data?.message) {
    return response.data.message;
  }
  if (typeof response.data === "string") {
    return response.data;
  }
  if (response.message) {
    return response.message;
  }
  if (typeof response.data !== "undefined") {
    return response.data;
  }
  return "Request failed";
}

function* loginUser({ payload: { user, history } }) {
  try {
    const loginPayload = {
      username: user.userName,
      password: EncryptPassword(user.password),
    };
    if (user.mfaCode) {
      loginPayload.mfaCode = user.mfaCode;
    }

    const response = yield call(postLogin, loginPayload);
    console.log("Login Response :: ", response);
    if (response && response.status === 200) {
      // post() wraps string bodies as { data: string, status }
      if (typeof response.data === "string") {
        yield put(loginUserSuccessfulWithVerification(response.data));
        return;
      }

      if (response.base64Image) {
        yield put(loginUserSuccessfulWithQrCode(response));
        return;
      }

      const { idToken, refreshToken } = response;
      console.log("--==response", response, idToken);
      console.log("Refresh Token", refreshToken);
      const decoded = jwtDecode(idToken);
      const { exp } = decoded;
      console.log("jwt_decode ::: > ", decoded, exp);
      localStorage.setItem("authUser", JSON.stringify(response));
      localStorage.setItem("Id Token", JSON.stringify(exp));
      localStorage.removeItem("lastActiveRoute");
      yield put(loginUserSuccessful(response));
      history.push("/details");
    } else {
      yield put(apiError({ message: getErrorMessage(response) }));
    }
  } catch (error) {
    console.log("Error :: ", error);
    if (error.response) {
      yield put(apiError({ message: getErrorMessage(error.response) }));
    } else if (error.request) {
      yield put(apiError({ message: "No response is received" }));
    } else {
      yield put(apiError({ message: error?.message }));
    }
  }
}

function* verifyTotp({ payload: { session, code } }) {
  try {
    const response = yield call(postVerifyTotp, { session, code });
    console.log("Verify TOTP Response :: ", response);
    if (response && response.status === 200) {
      let message = "MFA setup successful. Please log in again.";
      if (typeof response.data === "string" && response.data.trim()) {
        message = response.data;
      } else if (response.message) {
        message = response.message;
      }
      yield put(verifyTotpSuccessful(message));
    } else {
      yield put(apiError({ message: getErrorMessage(response) }));
    }
  } catch (error) {
    console.log("Verify TOTP Error :: ", error);
    if (error.response) {
      yield put(apiError({ message: getErrorMessage(error.response) }));
    } else if (error.request) {
      yield put(apiError({ message: "No response is received" }));
    } else {
      yield put(apiError({ message: error?.message }));
    }
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser");
    history.push("/login");
  } catch (error) {
    yield put(apiError(error));
  }
}
function* forceLogout() {
  try {
    localStorage.removeItem("authUser");
  } catch (error) {
    yield put(apiError(error));
  }
}

export function* clearAllLoginMessages() {
  console.log("Saga: clear all login messages");
  yield put(clearAllLoginMessagesSuccessful());
}

export function* watchUserLogin() {
  yield takeEvery(CHECK_LOGIN, loginUser);
}

export function* watchVerifyTotp() {
  yield takeEvery(VERIFY_TOTP, verifyTotp);
}

export function* watchUserLogout() {
  yield takeEvery(LOGOUT_USER, logoutUser);
}
export function* watchForceLogout() {
  yield takeEvery(FORCE_LOGOUT, forceLogout);
}

export function* watchClearAllLoginMessages() {
  yield takeEvery(CLEAR_ALL_LOGIN_MESSAGES, clearAllLoginMessages);
}

function* loginSaga() {
  yield all([fork(watchUserLogin), fork(watchUserLogout)]);
  yield all([fork(watchForceLogout)]);
  yield all([fork(watchClearAllLoginMessages)]);
  yield all([fork(watchVerifyTotp)]);
}

export default loginSaga;
